import { render } from "./ProducerFeedmillRateForm.vue?vue&type=template&id=20df25bf"
import script from "./ProducerFeedmillRateForm.vue?vue&type=script&lang=js"
export * from "./ProducerFeedmillRateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__